'use client'

import React, { useState } from 'react'
import FavoriteRedImg from '../../../assets/images/favorites-filled.svg'
import FavoriteImg from '../../../assets/images/favorites.svg'
import NoVideoImage from '../../../assets/images/no-video.svg'
import { useTranslations } from 'next-intl'
import { typeAlias, categoryAlias } from '../../../helpers/utils'
import { Col, Row } from 'reactstrap'
import ImageSlider from '../../../components/ImageSlider'
import Link from 'next/link'
import { APIClient } from '../../../helpers/api_helper'
import Card from '../../../components/Card'
import {YMaps, Map, Placemark, Circle} from '@pbe/react-yandex-maps';
import { isMobile } from 'react-device-detect'
import Image from 'next/image'
// @ts-ignore
import Modal from 'react-modal'
import {Sheet} from "react-modal-sheet";
// @ts-ignore
import Flatpickr from "react-flatpickr";

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ClientApartmentView = ({
  estateData = {},
  similarOffers = [],
  locale
}: {
  estateData: any
  similarOffers: any
  locale: string
}) => {
  const t = useTranslations('')

  const api = new APIClient()
  const headers = { 'Accept-Language': locale }
  const [isFavorite, setIsFavorite]: any = useState(false)
  const [formDataOrderCall, setFormDataOrderCall]: any = useState({
    type: 'Real estate',
    estate_code: estateData.code,
    name: '',
    phone: ''
  })
  const [requestSellNameOrderError, setRequestSellNameOrderError] = useState('')
  const [phoneOrderError, setPhoneOrderError] = useState('')

  const [requestShowIsOpen, setRequestShowIsOpen] = React.useState(false)
  const [orderCallIsOpen, setOrderCallIsOpen] = React.useState(false)
  const [requestShowIsOpenMobile, setRequestShowIsOpenMobile] =
    React.useState(false)
  const [orderCallIsOpenMobile, setOrderCallIsOpenMobile] =
    React.useState(false)
  const [requestSellNameRequestError, setRequestSellNameRequestError] =
    useState('')
  const [phoneRequestError, setPhoneRequestError] = useState('')
  const [dateRequestError, setDateRequestError] = useState('')
  const [timeRequestError, setTimeRequestError] = useState('')
  const [mapZoomSize, setMapZoomSize] = useState(isMobile ? 15 : 16);

  const [formDataRequestShow, setFormDataRequestShow]: any = useState({
    type: 'Request Show',
    name: '',
    phone: '',
    date: new Date().setDate(new Date().getDate() + 1),
    time: '12:00',
    is_showed: false
  })

  const symbols: any = {
    rub: '₽',
    amd: '֏'
  }

  const customStylesRequestShow: any = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      overflow: 'visible'
    }
  }

  const openRequestShowIsOpen = () => {
    setRequestShowIsOpen(true)
  }
  const openOrderCallIsOpen = () => {
    setOrderCallIsOpen(true)
  }

  const openRequestShowIsOpenMobile = () => {
    setRequestShowIsOpenMobile(true)
    setOrderCallIsOpenMobile(false)
  }
  const openOrderCallIsOpenMobile = () => {
    setOrderCallIsOpenMobile(true)
    setRequestShowIsOpenMobile(false)
  }

  function closeRequestShowModal() {
    setRequestShowIsOpen(false)
    setRequestShowIsOpenMobile(false)
  }

  function closeOrderCallModal() {
    setOrderCallIsOpen(false);
    setOrderCallIsOpenMobile(false)
  }

  const handleFavoriteClick = () => {

  }

  const handleInputChange = (e: any) => {
    const { name, value } = e.target
    setFormDataOrderCall((prevData: any) => ({
      ...prevData,
      [name]: value
    }))
  }

  const handleInputChangeRequestShow = (e: any) => {
    const { name, value } = e.target
    setFormDataRequestShow((prevData: any) => ({
      ...prevData,
      [name]: value
    }))
  }
  const handleOrderCallSubmit = async (event: any) => {
    event.preventDefault()

    let valid = true

    setRequestSellNameOrderError('')
    if (!formDataOrderCall.name) {
      setRequestSellNameOrderError(t('Name, surname should not be empty'))
      valid = false
    }

    setPhoneOrderError('')
    if (!formDataOrderCall.phone) {
      setPhoneOrderError(t('Phone should not be empty'))
      valid = false
    }

    if (!valid) {
      return
    }

    const requestData = new FormData()

    for (const key in formDataOrderCall) {
      if (typeof formDataOrderCall[key] === 'object') {
        for (const subKey in formDataOrderCall[key]) {
          requestData.append(
            `${key}[${subKey}]`,
            formDataOrderCall[key][subKey]
          )
        }
      } else {
        requestData.append(key, formDataOrderCall[key])
      }
    }

    try {
      const requestData = {
        name: formDataRequestShow.name,
        phone: formDataRequestShow.phone
      }

      api.create(`/contact-us`, formDataOrderCall).then(data => {
        setFormDataOrderCall({
          type: 'Real estate',
          estate_code: estateData.code,
          name: '',
          phone: ''
        })
        setOrderCallIsOpen(false)
      })

      window.location.href = `/${locale}/thank-you`
    } catch (error) {
      console.error('Error submitting form', error)
    }
  }

  const handleRequestShowSubmit = async (event: any) => {
    event.preventDefault()

    let valid = true

    setRequestSellNameRequestError('')
    if (!formDataRequestShow.name) {
      setRequestSellNameRequestError(t('Name, surname should not be empty'))
      valid = false
    }

    setPhoneRequestError('')
    if (!formDataRequestShow.phone) {
      setPhoneRequestError(t('Phone should not be empty'))
      valid = false
    }

    setDateRequestError('')
    if (!formDataRequestShow.date) {
      setDateRequestError(t('Date should not be empty'))
      valid = false
    }

    setTimeRequestError('')
    if (!formDataRequestShow.time) {
      setTimeRequestError(t('Time should not be empty'))
      valid = false
    }

    if (!valid) {
      return
    }

    const requestData = new FormData()
    for (const key in formDataRequestShow) {
      if (typeof formDataRequestShow[key] === 'object') {
        for (const subKey in formDataRequestShow[key]) {
          requestData.append(
            `${key}[${subKey}]`,
            formDataRequestShow[key][subKey]
          )
        }
      } else {
        requestData.append(key, formDataRequestShow[key])
      }
    }

    try {
      let dateString: any = formDataRequestShow.date
      let timeString: any = formDataRequestShow.time
      dateString = new Date(dateString)
      timeString = new Date(timeString)

      const year = dateString.getUTCFullYear()
      const month = (dateString.getUTCMonth() + 1).toString().padStart(2, '0') // Months are zero-indexed
      const day = dateString.getUTCDate().toString().padStart(2, '0')

      const hours = timeString.getUTCHours()
      const minutes = timeString.getUTCMinutes()

      timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
      dateString = `${year}-${month}-${day}`

      const requestData = {
        type: 'Request Show',
        estate_code: estateData.code,
        name: formDataRequestShow.name,
        phone: formDataRequestShow.phone,
        date: dateString,
        time: timeString,
        is_showed: false
      }

      api.create(`/contact-us`, requestData).then(data => {
        setFormDataRequestShow({
          type: 'Request Show',
          estate_code: estateData.code,
          name: '',
          phone: '',
          date: '',
          time: '',
          is_showed: false
        })

        window.location.href = `/${locale}/thank-you`
      })
    } catch (error) {
      console.error('Error submitting form', error)
    }
  }

  const getParamValue = (paramId: any) => {
    const parameters = estateData.parameters

    if (!parameters) {
      return ''
    } else if (!parameters[paramId]) {
      return ''
    } else if (typeof parameters[paramId] === 'object') {
      let returnString = ''

      if (parameters[paramId].value) {
        returnString = parameters[paramId].value
      }

      return returnString
    } else {
      return parameters[paramId]
    }
  }

  const getSource = (url: any) => {
    try {
      const domain = new URL(url).hostname
        .replace(/^www\./, '')
        .split('.')[0];

      return domain.charAt(0).toUpperCase() + domain.slice(1);
    } catch (error) {
      return 'Unknown';
    }
  }

  const getTitleText = (estateData: any) => {
    if (estateData.type === 1) {
      if (estateData.category === 6) {
        return `${t(categoryAlias[estateData.category])}`
      } else if (estateData.category === 7) {
        if (locale == 'hy') {
          return `${t('for ' + typeAlias[estateData.type])} ${getParamValue('11')} ${t('Room')} ${t(categoryAlias[estateData.category])}`
        } else {
          return `${getParamValue('11')} ${t('Room')} ${t(categoryAlias[estateData.category])} ${t('for ' + typeAlias[estateData.type])} `
        }
      } else if (estateData.category === 8) {
        return `${t(categoryAlias[estateData.category])}`
      } else {
        if (locale == 'hy') {
          return `${t('for ' + typeAlias[estateData.type])} ${getParamValue('11')} ${t('Room')} ${t(categoryAlias[estateData.category])}`
        } else {
          return `${getParamValue('11')} ${t('Room')} ${t(categoryAlias[estateData.category])} ${t('for ' + typeAlias[estateData.type])} `
        }
      }
    } else {
      if (estateData.category === 6) {
        return `${t(categoryAlias[estateData.category])}`
      } else if (estateData.category === 7) {
        if (locale == 'hy') {
          return `${t('for ' + typeAlias[estateData.type])} ${getParamValue('11')} ${t('Room')} ${t(categoryAlias[estateData.category])}`
        } else {
          return `${getParamValue('11')} ${t('Room')} ${t(categoryAlias[estateData.category])} ${t('for ' + typeAlias[estateData.type])} `
        }
      } else if (estateData.category === 8) {
        return `${t(categoryAlias[estateData.category])}`
      } else {
        if (locale == 'hy') {
          return `${t('for ' + typeAlias[estateData.type])} ${getParamValue('11')} ${t('Room')} ${t(categoryAlias[estateData.category])}`
        } else {
          return `${getParamValue('11')} ${t('Room')} ${t(categoryAlias[estateData.category])} ${t('for ' + typeAlias[estateData.type])} `
        }
      }
    }
  }

  return (
    <main>
      <section className='estate-view-container container-main'>
        <div className='estate-view-container-left'>
          <div className='estate-view-container-left-header'>
            <div className='estate-view-container-left-header-left'>
              <p className='estate-title'>
                {getTitleText(estateData)}
              </p>
              <h1 className='estate-view-address-line mobile'>
                {estateData.address}
              </h1>
              <p className='estate-code mobile'>
                <span>{t('Code')}:</span> {estateData.code}
              </p>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <h1 className='estate-view-address-line no-mobile'>
              <span>{estateData.address}</span>
            </h1>

            <p className='estate-code no-mobile'>
              <span>{t('Code')}:</span> {estateData.code}
            </p>
          </div>

          <div className='estate-view-container-left-content'>
            <div className='estate-view-container-left-content-left'>
              <div className='estate-view-container-left-content-right-title'>
                <div
                  className='control-favicon'
                  style={{ marginRight: '20px' }}
                  onClick={handleFavoriteClick}
                >
                  <Image
                    loading='lazy'
                    src={isFavorite ? FavoriteRedImg : FavoriteImg}
                    alt='heart-highlighted.svg'
                    data-id={1}
                  />
                </div>
              </div>

              <ImageSlider images={estateData.images} estateData={estateData} />

              {estateData.youtube_url && (
                <div className='description-section mobile mb-24'>
                  <h3 className='block-title'>{t('Video Content')}</h3>
                  <div className='video-row'>
                    <div className='video-row-left'>
                      <div className='video-block-image'>
                        <Image src={NoVideoImage} alt='No Video' />
                      </div>
                      <div className='video-block-source no-mobile'>
                        <span>{t('Source')}:</span>
                        <span className='video-block-source'> {getSource(estateData.youtube_url)}</span>
                      </div>
                    </div>
                    <div className='video-row-right'>
                      <Link href={estateData.youtube_url} target='_blank'>
                        <i className='fa fa-play'></i>{' '}
                        <span className='no-mobile'>
                          {t('Watch the Video')}
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              )}

              <div className='estate-view-container-left-content-right info-list d-none for-mobile'>
                <div className='currencies secondary info-list-item'>
                  <h3 className='info-list-label-price'>{t('Price')}</h3>
                  <div className='card-price-container'>
                    <p className='root_currency' id='each-579523'>
                      $ {estateData.price}
                    </p>
                    <ul
                      className='other_currencies open-bottom'
                      data-open='each-579523'
                    >
                      {Object.keys(estateData.other_currencies).map(
                        (currency, index) => (
                          <li key={index} className='currency_item'>
                            {symbols[currency]}{' '}
                            {estateData.other_currencies[currency]}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                </div>
                <div className='estate-view-icons info-list'>
                  {Object.entries(estateData.parameters).map(
                    ([key, feature]: any, index: any) => {
                      if (
                        typeof feature !== 'object' ||
                        feature === null ||
                        !feature.name
                      ) {
                        return null
                      }

                      return (
                        <div className='estate-view-icons-item' key={index}>
                          <div className='estate-view-single-icon info-list-item'>
                            <span className='info-list-label'>
                              {feature.name}
                            </span>
                            <span className='info-list-value'>
                              {feature.value}
                            </span>
                          </div>
                        </div>
                      )
                    }
                  )}

                  <div className='addition-info'>
                    <button
                      className='btn btn-outline-primary no-mobile'
                      onClick={openRequestShowIsOpen}
                    >
                      {t('Request Showing')}
                    </button>
                    <button
                      className='btn btn-primary btn-filled no-mobile request-button'
                      onClick={openOrderCallIsOpen}
                    >
                      {t('Order Call')}
                    </button>

                    <button
                      className='btn btn-outline-primary mobile'
                      onClick={openRequestShowIsOpenMobile}
                    >
                      {t('Request Showing')}
                    </button>
                    <button
                      className='btn btn-primary btn-filled mobile request-button'
                      onClick={openOrderCallIsOpenMobile}
                    >
                      {t('Order Call')}
                    </button>
                  </div>
                </div>
              </div>

              {estateData.youtube_url && (
                <div className='description-section no-mobile'>
                  <h3 className='block-title'>{t('Video Content')}</h3>

                  <div className='video-row'>
                    <div className='video-row-left'>
                      <div className='video-block-image'>
                        <Image src={NoVideoImage} alt='No Video' />
                      </div>
                      <div className='video-block-source no-mobile'>
                        <span>{t('Source')}:</span>
                        <span className='video-block-source'> {getSource(estateData.youtube_url)}</span>
                      </div>
                    </div>
                    <div className='video-row-right'>
                      <Link href={estateData.youtube_url} target='_blank'>
                        <i className='fa fa-play'></i>{' '}
                        <span className='no-mobile'>
                          {t('Watch the Video')}
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              )}

              <div className='description-section description-section-description'>
                <h3 className='block-title'>{t('Description')}</h3>
                <p className='block-content'>{estateData.description}</p>
              </div>

              <div className='additional-info-list'>
                <h3 className='block-title'>{t('Additional information')}</h3>
                <div className='block-content'>
                  <ul className='list-group'>
                    {estateData.additional_information &&
                      Object.entries(estateData.additional_information).map(
                        (additionalParam: any, index: number) => {
                          return (
                            <li key={index}>
                              <i className='icon-check'></i>
                              <p className='additional-info-col'>
                                {additionalParam[1]}
                              </p>
                            </li>
                          )
                        }
                      )}
                  </ul>
                </div>
              </div>
              <div className='map'>
                <br />
                <h3 className='block-title'>{t('Map')}</h3>
                <div id='map' className='w-100 map-container text-center'>
                  <YMaps>
                    <Col>
                      <Map
                        defaultState={{
                          center: [
                            estateData.latitude ?? 40.177628,
                            estateData.longitude ?? 44.512546
                          ],
                          zoom: mapZoomSize
                        }}
                        width='100%'
                        height='400px'
                      >
                        {estateData.show_in_map && (
                          <Placemark
                            geometry={[
                              estateData.latitude,
                              estateData.longitude
                            ]}
                          />
                        )}
                        {!estateData.show_in_map && (
                          <Circle
                            geometry={[
                              [estateData.latitude, estateData.longitude],
                              estateData.radius
                            ]}
                            options={{
                              draggable: false,
                              fillColor: '#DB709377',
                              strokeColor: '#990066',
                              strokeOpacity: 0.8,
                              strokeWidth: 5
                            }}
                          />
                        )}
                      </Map>
                    </Col>
                  </YMaps>
                </div>
              </div>
            </div>
            <div
              className={`estate-view-container-left-content-right info-list`}
              id='infoList'
            >
              {estateData.id && (
                <>
                  <div className='currencies secondary info-list-item'>
                    <h3 className='info-list-label-price'>{t('Price')}</h3>
                    <div className='card-price-container'>
                      <p className='root_currency' id='each-579523'>
                        $ {estateData.price}
                      </p>
                      <ul
                        className='other_currencies open-bottom'
                        data-open='each-579523'
                      >
                        {Object.keys(estateData.other_currencies).map(
                          (currency, index) => (
                            <li key={index} className='currency_item'>
                              {symbols[currency]}{' '}
                              {estateData.other_currencies[currency]}
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  </div>
                  <div className='estate-view-icons info-list'>
                    {Object.entries(estateData.parameters).map(
                      ([key, feature]: any, index: number) => {
                        if (
                          typeof feature !== 'object' ||
                          feature === null ||
                          !feature.name
                        ) {
                          return null
                        }

                        return (
                          <div className='estate-view-icons-item' key={index}>
                            <div className='estate-view-single-icon info-list-item'>
                              <span className='info-list-label'>
                                {feature.name}
                              </span>
                              <span className='info-list-value'>
                                {feature.value}
                              </span>
                            </div>
                          </div>
                        )
                      }
                    )}
                    <div className='addition-info'>
                      <button
                        className='btn btn-outline-primary'
                        onClick={openRequestShowIsOpen}
                      >
                        {t('Request Showing')}
                      </button>
                      <button
                        className='btn btn-primary btn-filled request-button'
                        onClick={openOrderCallIsOpen}
                      >
                        {t('Order Call')}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className='container-main '>
        <div className='section-title-container'>
          <h2 className='section-title'>{t('Similar offers')}</h2>
        </div>

        <Row style={{ paddingBottom: '90px' }}>
          {similarOffers.map((item: any, index: number) => (
            <Col md={4} className='mb-24' key={index}>
              <Card
                key={item.id}
                data={item}
                category={item.category}
                isHomePage={true}
                withSlider={true}
              />
            </Col>
          ))}
        </Row>
      </section>

      <Modal
        isOpen={requestShowIsOpen || requestShowIsOpenMobile}
        onRequestClose={closeRequestShowModal}
        style={customStylesRequestShow}
        className="orderCallModal"
        overlayClassName="estateViewOverlay"
        contentLabel="Request Show"
      >
        <button className="close-button" onClick={closeRequestShowModal}>✖</button>
        <h2>{t('Request Show')}</h2>
        <p>{t('Choose Date and Time to See the Property')}</p>

        <form onSubmit={handleRequestShowSubmit}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group text-left">
                <input className="form-control" type="text" name="name"
                       id="name" placeholder={t('Name, Surname')}
                       value={formDataRequestShow.name}
                       onChange={handleInputChangeRequestShow} />
                <small className="text-danger"></small>
                {requestSellNameRequestError &&
                  <small className="text-danger">{requestSellNameRequestError}</small>}
              </div>
              <div className="form-group text-left">
                <Flatpickr
                  // selected={startDate}
                  value={formDataRequestShow.date}
                  // onChange={handleInputChangeDateRequestShow('date')}
                  // popperPlacement="top-end"
                />
                {dateRequestError && <small className="text-danger">{dateRequestError}</small>}
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group text-left">
                <div className="input-group">
                  <span className="input-group-text" id="basic-addon1">+374</span>
                  <input className="form-control" name="phone" type="number" id="phone"
                         placeholder={t('Tel')} value={formDataRequestShow.phone}
                         onChange={handleInputChangeRequestShow} />
                </div>
                {phoneRequestError && <small className="text-danger">{phoneRequestError}</small>}
              </div>
              <div className="form-group text-left">
                <Flatpickr
                  value={formDataRequestShow.time}
                  options={{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    minuteIncrement: 15,
                    time_24hr: true,
                  }}
                />
                {timeRequestError && <small className="text-danger">{timeRequestError}</small>}
              </div>
            </div>
          </div>

          <div className="form-group">
            <button type="submit" className="btn submit-contact-btn">{t('Confirm')}</button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={orderCallIsOpen || orderCallIsOpenMobile}
        onRequestClose={closeOrderCallModal}
        style={customStylesRequestShow}
        className="orderCallModal"
        overlayClassName="estateViewOverlay"
        contentLabel="Order Call"
      >
        <button className="close-button" onClick={closeOrderCallModal}>✖</button>
        <h2>{t('Order Call')}</h2>
        <p>{t('Leave a phone number and our specialist will provide more details')}</p>

        <form onSubmit={handleOrderCallSubmit}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group text-left mt-3">
                <input className="form-control" type="text" name="name"
                       id="name" placeholder={t('Name, Surname')}
                       autoComplete={'off'}
                       value={formDataOrderCall.name} onChange={handleInputChange} />
                <small className="text-danger"></small>
                {requestSellNameOrderError && <small className="text-danger">{requestSellNameOrderError}</small>}
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group text-left">
                <div className="input-group">
                  <input className="form-control" name="phone" type="number" id="phone"
                         placeholder={t('Tel')} value={formDataOrderCall.phone}
                         autoComplete={'off'}
                         onChange={handleInputChange} />
                  <small className="text-danger"></small>
                </div>
                {phoneOrderError && <small className="text-danger">{phoneOrderError}</small>}
              </div>
            </div>
          </div>

          <div className="form-group">
            <button type="submit" className="btn submit-contact-btn">{t('Confirm')}</button>
          </div>
        </form>
      </Modal>

      <a className="call-now btn btn-primary btn-filled d-block d-md-none" id="call-now"
         href="tel:+37491279393">
        <i className="fas fa-phone fa-rotate-90" style={{'fontSize': '19px', 'marginRight': '5px'}}></i> { t('Call')}
      </a>
    </main>
  )
}

export default ClientApartmentView
